export enum ApplianceDetailsFormField {
  ApplianceCode = 'applianceCode',
  BrandCode = 'brandCode',
  ModelNumber = 'modelNumber',
  PartsWarranty = 'partsWarranty',
  PurchaseDate = 'purchaseDate',
  PurchasePrice = 'purchasePrice',
  Retailer = 'retailer',
  SerialNumber = 'serialNumber',
  Warranty = 'warranty',
}
